<template>
    <div>
        <b-container fluid>
            <header-buttons
                :buttons="headerButtons"
            ></header-buttons>
            <b-row>
                <b-col cols="12" class="mb-3">
                    <h3 class="text-center text-primary text-uppercase">
                        {{adminRequestCurrent.user.data.society}}
                    </h3>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <b-alert show class="text-center shadow" :variant="variantStatus">
                        <p>Stato richiesta:</p>
                        <h3 class="alert-heading text-uppercase">{{labelStatus}}</h3>
                    </b-alert>
                </b-col>
            </b-row>
        </b-container>
        <hr>
        <society-matches-request-details
            :key="societyMatchesRequestDetailsKey"
            :sectorBusySeats="sectorBusySeats"
            :sectorTotalSeats="sectorTotalSeats"
            :juniorTickets="juniorTickets.length"
            :seniorTickets="seniorTickets.length"
            :requestStatus="{variant: variantStatus, label: labelStatus}"
            :extraJunior="extraJunior"
            :matchRequest="adminRequestCurrent">
        </society-matches-request-details>
        <hr>
        <b-container>
            <b-row>
                <b-col cols="12" md="6">
                    <inter-card class="mb-3"
                                titleIcon="flaticon-info"
                                title="cambia stato">
                        <b-row>
                            <b-col cols="12">
                                <inter-select
                                    :key="statusSelectedKey"
                                    label="Cambia stato richiesta"
                                    :optionSelected="adminRequestCurrent.status"
                                    v-model="statusSelected"
                                    :options="statusSelectOptions"
                                ></inter-select>
                            </b-col>
                        </b-row>
                        <hr>
                        <b-row>
                            <b-col cols="12" class="text-center">
                                <b-form-checkbox v-model="sendEmail" switch>
                                    Invia email alla società per il cambio stato
                                </b-form-checkbox>
                            </b-col>
                        </b-row>
                        <hr>
                        <b-row>
                            <b-col cols="12">
                                <inter-button class="mx-auto"
                                              label="Cambia stato"
                                              :confirm="true"
                                              @onClick="changeStatus()">
                                </inter-button>
                            </b-col>
                        </b-row>
                    </inter-card>
                </b-col>
                <b-col cols="12" md="6">
                    <inter-card class="mb-3"
                                titleIcon="flaticon-upload"
                                title="Carica biglietti">
                        <div v-if="this.tickets==null">
                            <admin-request-upload-ticket-direct-upload/>
                        </div>
                        <div class="my-3" v-if="this.tickets!=null">
                            <div class="d-flex justify-content-center">
                                <div class="text-center">
                                    <h1 class="text-success mb-3"><i class="fi flaticon-movie-tickets"></i></h1>
                                    <p class="mb-0 text-uppercase">
                                        {{ adminRequestCurrent.media[this.tickets].filename }}
                                        biglietti caricati il {{adminRequestCurrent.media[this.tickets].created_at | date}}
                                    </p>
                                    <small>Dim. {{(adminRequestCurrent.media[this.tickets].size/1000) | decimal}} Kb</small>
                                </div>
                            </div>
                            <hr>
                            <div class="d-flex justify-content-center mt-3">
                                <div>
                                    <inter-button class="mx-3"
                                                  @onClick="downloadTickets"
                                                  label="Scarica">
                                    </inter-button>
                                </div>
                                <div>
                                    <inter-button class="mx-3"
                                                  @onClick="removeTickets"
                                                  label="Elimina"
                                                  :confirm="true">
                                    </inter-button>
                                </div>
                            </div>
                        </div>
                    </inter-card>
                </b-col>
                <b-col cols="12" md="6" v-if="this.distinta !=null">
                    <inter-card class="mb-3"
                                titleIcon="flaticon-upload"
                                title="Distinta bonifico">
                        <div class="my-3">
                            <div class="d-flex justify-content-center">
                                <div class="text-center">
                                    <h1 class="text-success mb-3"><i class="fi flaticon-movie-tickets"></i></h1>
                                    <p class="mb-0 text-uppercase">
                                        {{ adminRequestCurrent.media[this.distinta].filename }}
                                        Bonifico caricato il {{adminRequestCurrent.media[this.distinta].created_at | date}}
                                    </p>
                                    <small>Dim. {{(adminRequestCurrent.media[this.distinta].size/1000) | decimal}} Kb</small>
                                </div>
                            </div>
                            <hr>
                            <div class="d-flex justify-content-center mt-3">
                                <div>
                                    <inter-button class="mx-3"
                                                  @onClick="downloadTickets"
                                                  label="Scarica">
                                    </inter-button>
                                </div>
                            </div>
                        </div>
                    </inter-card>
                </b-col>
            </b-row>
        </b-container>
        <hr>
        <b-container>
            <b-row>
                <b-col cols="12" md="6">
                    <b-row>
                        <b-col>
                            <h3 class="text-primary text-uppercase mb-3">
                                Biglietti per accompagnatori
                            </h3>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="mb-3"
                               v-for="(contact, index) in seniorTickets" v-bind:key="index" cols="12" md="6">
                            <society-contact-container
                                :confirmAction="false"
                                :contact="contact"></society-contact-container>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="12" md="6">
                    <b-row>
                        <b-col>
                            <h3 class="text-primary text-uppercase mb-3">
                                Biglietti per atleti
                            </h3>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="mb-3"
                               v-for="(contact, index) in juniorTickets" v-bind:key="index" cols="12" md="6">
                            <society-contact-container
                                :confirmAction="false"
                                :contact="contact"></society-contact-container>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>

        <inter-modal :title-icon="iconModal"
                     :buttonPrimary="buttonPrimaryModal"
                     :title="titleModal"
                     :visible="showModal"
                     @onPrimaryClick="sendChangeStatus(true)">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <p>Inserisci un testo per personalizzare l'email.<br>
                            Lasciando bianco questo spazio, l'email verrà inviata con il testo standard</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <inter-rich-text @onEditorUpdate="(value) => {textEmail = value}"></inter-rich-text>
                    </b-col>
                </b-row>
            </b-container>
        </inter-modal>
    </div>
</template>

<script>

import {mapGetters, mapMutations, mapActions} from 'vuex';
import Utils from "@/utils";
import TicketService from "@/services/ticket-service";
import HeaderButtons from "../../../components/headers-buttons/HeaderButtons";
import SocietyMatchesRequestDetails
    from "../../society-matches/components/society-matches-request-details/SocietyMatchesRequestDetails";
import InterCard from "../../../components/card/InterCard";
import InterSelect from "../../../components/form/inter-select/InterSelect";
import InterButton from "../../../components/form/inter-button/InterButton";
import SocietyContactContainer from "../../society-contacts/components/contact-container/SocietyContactContainer";
import InterModal from "../../../components/modal/InterModal";
import InterRichText from "../../../components/inter-rich-text/InterRichText";
import _ from "lodash";
import AdminRequestUploadTicketDirectUpload from "../components/AdminRequestUploadTicketDirectUpload";

export default {
    name: "AdminRequestsDetailsView",
    components: {
        AdminRequestUploadTicketDirectUpload,
        InterRichText,
        InterModal,
        SocietyContactContainer,
        InterButton, InterSelect, InterCard, SocietyMatchesRequestDetails, HeaderButtons
    },
    data() {
        return {
            headerButtons: [],
            sectorBusySeats: 0,
            sectorTotalSeats: 0,
            societyMatchesRequestDetailsKey: 1,
            requestStatuses: Utils.getRequestStatuses(),
            statusSelected: null,
            sendEmail: true,
            iconModal: 'mail',
            titleModal: 'Invia email',
            showModal: false,
            buttonPrimaryModal: {
                label: 'Invia',
                confirm: true
            },
            textEmail: '',
            file: null,
            fileToUpload: {},
            response: null,
            statusSelectedKey: 1,
            tickets: null,
            distinta: null
        }
    },
    computed: {

        ...mapGetters(['adminRequestCurrent']),

        labelStatus: function () {
            const statusSetting = Utils.getRequestStatusSettings(this.adminRequestCurrent.status);
            return statusSetting ? statusSetting.label : 'N.D.';
        },

        variantStatus: function () {
            const statusSetting = Utils.getRequestStatusSettings(this.adminRequestCurrent.status);
            return statusSetting ? statusSetting.variant : 'N.D.';
        },

        juniorTickets: function () {
            return TicketService.getJuniorTickets(this.adminRequestCurrent.details);
        },

        seniorTickets: function () {
            return TicketService.getSeniorTickets(this.adminRequestCurrent.details);
        },

        extraJunior: function () {
            return this.seniorTickets.length - (this.juniorTickets.length * this.adminRequestCurrent.match.adult_vs_childs);
        },

        statusSelectOptions: function () {
            return _.map(this.requestStatuses, (item, index) => {
                return {
                    name: item.label.toUpperCase(),
                    value: index
                }
            })
        },


    },
    mounted() {

        const index = this.adminRequestCurrent.media.findIndex(
            (media) => media.directory.includes("bonifico"));
        this.distinta = index !== -1 ? index : null;
        if(index == -1)
            if(this.adminRequestCurrent.media.length > 0)
                this.tickets = 0
            else{
                if(this.adminRequestCurrent.media.length > 1)
                    this.tickets = this.adminRequestCurrent.media.length -1 - index;
            }
        this.setBreadcrumbActive(
            this.adminRequestCurrent.user.data.society + ' ( ' +
            Utils.setDateFormatITA(this.adminRequestCurrent.match.date)
            + ' - ' + this.adminRequestCurrent.match.opponent + ' )'
        );

        this.societyMatchesGetSectorAvailability({
            idMatch: this.adminRequestCurrent.match.id,
            idSector: this.adminRequestCurrent.sector.id,
        }).then((data) => {
            this.sectorBusySeats = data.busy;
            this.sectorTotalSeats = data.total;
        }).catch();

        this.$root.$on('bv::modal::hide', () => {
            this.showModal = false;
        })

    },

    methods: {
        ...mapMutations([
            'setBreadcrumbActive',
        ]),

        ...mapActions({
            societyMatchesGetSectorAvailability: 'societyMatchesGetSectorAvailability',
            adminRequestsChangeStatus: 'adminRequestsChangeStatus',
            adminRequestsRemoveTickets: 'adminRequestsRemoveTickets',
            commonDownloadFile: 'commonDownloadFile',
        }),

        changeStatus: function () {
            if (!this.statusSelected) {
                this.$bvToast.toast('Devi selezionare uno stato', {
                    title: 'Alert',
                    variant: 'warning'
                });
                return;
            }

            if (this.statusSelected === this.adminRequestCurrent.status) {
                this.$bvToast.toast('Non puoi cambiare nel tuo stesso stato', {
                    title: 'Alert',
                    variant: 'warning'
                });
                return;
            }

            if (this.sendEmail) {
                this.showModal = true;
            } else {
                this.sendChangeStatus();
            }

        },

        sendChangeStatus: function (closeModal) {
            this.adminRequestsChangeStatus({
                id: this.adminRequestCurrent.id,
                status: this.statusSelected,
                sendEmail: this.sendEmail,
                textEmail: this.textEmail
            }).then(() => {
                this.$bvToast.toast('Stato aggiornato correttamente', {
                    title: 'Success',
                    variant: 'success'
                });
                if (closeModal) {
                    this.showModal = false;
                }
                this.statusSelectedKey += 1;
            }).catch(() => {
                this.$bvToast.toast('Stato non aggiornato', {
                    title: 'Alert',
                    variant: 'warning'
                });

                if (closeModal) {
                    this.modal = false;
                }
            })
        },



        removeTickets: function () {
            this.adminRequestsRemoveTickets(this.adminRequestCurrent)
                .then(() => {
                    this.$bvToast.toast('Biglietti rimossi correttamente', {
                        title: 'Success',
                        variant: 'success'
                    });
                })
                .catch(() => {
                    this.$bvToast.toast('Problemi nella rimozione dei biglietti', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                })
        },



        downloadTickets: function () {
            this.commonDownloadFile({
                url: this.adminRequestCurrent.media[0].url,
                filename: this.adminRequestCurrent.media[0].filename +
                    '.' + this.adminRequestCurrent.media[0].extension
            }).then()
                .catch(() => {
                    this.$bvToast.toast('Problema download', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                })
        },

    }
}
</script>

<style scoped>

</style>
